// /**
//  * Created by fangyang on 2017/7/13.
//  */
// import Vue from 'vue'
// import Vuex from 'vuex'
// import vuexI18n from 'vuex-i18n'
// import actions from './actions'
// import mutations from './mutations'
// import translationsEn from '@/locales/translateEn'
// import translationsCn from '@/locales/translateZh-CN'
// // import createPersistedState from 'vuex-persistedstate'
// // import * as Cookies from 'js-cookie'
// Vue.use(Vuex)
// const state = {
//     list: [],
//     page: {},
//     detailObj: {},
//     isShowLoading: false,
//     cookie: null,
//     contactsList: [], //通讯录列表
//     monthList: [], //月份列表
//     selectedMonth: null, //默认月份
//     tabList: [],
//     tabPage: {},
//     detailItem: {},
//     tab2List: [],
//     tab2Page: {},
//     saveTab: 1, //在双列表页面  保存点击是哪个,默认是1
//     isNetError: false,
//     url: '',
//     detailBean: '',
//     requestFlag: true,
//     leavallInfo: {},
//     sign: "",
//     defaultTheme:'',
//     sidebarOpened:false//左侧菜单伸缩状态  true收缩   false展开
// };
// const getters = {
//     getList: state => {
//         return state.list
//     },
//     getPage: state => {
//         return state.page
//     },
//     getDetailObj: state => {
//         return state.detailObj
//     },
//     getIsShowLoading: state => {
//         return state.isShowLoading
//     },
//     getContactsList: state => {
//         return state.contactsList
//     },
//     getMonthList: state => {
//         return state.monthList
//     },
//     getSelectedMonth: state => {
//         return state.selectedMonth
//     },
//     getTabList: state => {
//         return state.tabList
//     },
//     getTabPage: state => {
//         return state.tabPage
//     },
//     getDetailItem: state => {
//         return state.detailItem
//     },
//     getTab2List: state => {
//         return state.tab2List
//     },
//     getTab2Page: state => {
//         return state.tab2Page
//     },
//     getSaveTab: state => {
//         return state.saveTab
//     },
//     getIsNetError: state => {
//         return state.isNetError;
//     },
//     getUrl: state => {
//         return state.url;
//     },
//     getRequestFlag: state => {
//         return state.requestFlag;
//     },
//     getLeavallInfo: state => {
//         return state.leavallInfo;
//     },
//     getSidebarOpened: state => {
//       return state.sidebarOpened;
//     }
// }

// const store = new Vuex.Store({
//     state,
//     getters,
//     mutations,
//     actions,
//     modules: {
//         i18n: vuexI18n.store
//     }
//     // ,
//     // plugins: [
//     //   createPersistedState()
//     // ]
// });

// Vue.use(vuexI18n.plugin, store, 'i18n', ['{{' / '}}']);
// Vue.i18n.add('en', translationsEn);
// Vue.i18n.add('cn', translationsCn);

// Vue.i18n.fallback('cn');

// export default store;

import Vue from 'vue'
import Vuex from 'vuex'
//import getters from './getters'
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
// const modulesFiles = require.context('./modules', true, /\.js$/)

// // you do not need `import app from './modules/app'`
// // it will auto require all vuex module from modules file
// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   // set './app.js' => 'app'
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//   const value = modulesFiles(modulePath)
//   modules[moduleName] = value.default
//   return modules
// }, {})

const store = new Vuex.Store({
    state: {
        areacode: "340755",
        pageTabs: [], // 页面tab
        pageTabValue: "", // 页面tab选中值
        anchorShrinkState: false, // 右侧锚定块，默认展开
        curAnchorId: "", // 当前锚定的id值
        timestamp:"",
        sidebarOpened: false,
        loadingState: false // loading锁屏
    },
    mutations: mutations,
    actions: actions
 // modules,
 // getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js